import { useAuthUser } from "Components/Auth/hooks/useAuthUser";
import { getProjectTrees } from "../ProjectHelper";
import { useProjects } from "./useProjects";

export const useActiveProjectTrees = () => {
	const userId = useAuthUser((state) => state.user?.uid);
	const projects = useProjects((state) => state.projects);

	if (!userId) return [];

	const unarchivedProjects = projects.filter((project) =>
		(project.membersActive || []).includes(userId)
	);

	return getProjectTrees(unarchivedProjects);
};
